(function(){
    let el_iframe = document.getElementById('video-player-embed');
    let el_iframe_two = document.getElementById('video-player-embed-two');
    let orig_x = el_iframe.width;
    let orig_y = el_iframe.height;
    let aspect_ratio = orig_y / orig_x;
    let playing_url = '';
    const breakpoint = 768;
    const mobile_width = 356-28;

    let el_shade = document.getElementById('video-modal-shade');
    let el_overlay = document.getElementById('video-modal-overlay');

    let el_shade_two = document.getElementById('video-modal-shade-two');
    let el_overlay_two = document.getElementById('video-modal-overlay-two');

    let el_activate = document.getElementById('video-show-element');
    let el_activate_two = document.getElementById('video-show-element-two');
    
    let el_player = document.getElementById('video-player-embed');

    let opening = false;

    function rescale() {
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if (vw > breakpoint) {
            // Desktop
            el_iframe.width = orig_x;
            el_iframe.height = orig_y;
        }
        else {
            // Mobile
            el_iframe.width = mobile_width;
            el_iframe.height = mobile_width * aspect_ratio;
        }
    }

    function show() {
        el_shade.style['display'] = 'block';
        el_overlay.style['display'] = 'flex';
        opening = true;
        el_iframe.src = playing_url;
    }

    function showTwo() {
        el_shade_two.style['display'] = 'block';
        el_overlay_two.style['display'] = 'flex';
        opening = true;
        el_iframe_two.src = playing_url_two;
    }

    function hide() {
        if (opening) {
            opening = false;
            return;
        }
        el_shade.style['display'] = 'none';
        el_overlay.style['display'] = 'none';
        el_iframe.src = 'about:blank';

        if (el_shade_two) {
            el_shade_two.style['display'] = 'none';
        }
        if (el_overlay_two) {
            el_overlay_two.style['display'] = 'none';
        }
        if (el_iframe_two) {
            el_iframe_two.src = 'about:blank';
        }
    }

    function halt_bubble(e) {
        e.stopPropagation();
    }

    playing_url = el_iframe.src;
    if (el_iframe_two) {
        playing_url_two = el_iframe_two.src;
    }

    document.addEventListener('click', hide);
    el_activate.addEventListener('click', show);
    if (el_activate_two) {
        el_activate_two.addEventListener('click', showTwo);
    }
    el_player.addEventListener('click', halt_bubble);

    window.addEventListener('resize', rescale);
    rescale();
})();
